import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import VideoTriangleIcon from '../icons/video-triangle'
import CloseIcon from '../icons/close'

const QuestionVideoContainer = styled.div`
  border-radius: 5px;
  position: relative;
  margin-right: 12px;
  cursor: pointer;
  img {
    border-radius: 5px;
    position: relative;
  }
`
const QuestionVideContainerFilter = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  opacity: 1;
  border-radius: 5px;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
`

const QuestionVideoOverlayContainer = styled.div`
  display: ${(props) => (props.visible ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 2000;
  overflow: auto;
  flex-direction: column;
`

const QuestionVideoPoster = styled.img`
  max-width: 120px;
`

const QuestionVideo = styled.video`
  position: relative;
  display: inline;
  height: auto;
  width: auto;
  margin: 0;
  max-width: 100%;
  border-radius: 5px;
  margin-right: 0px !important;
  padding: 20px 35px 20px 20px;
`
const CloseIconContainer = styled.div`
  width: 100%;
  max-width: 850px;
  margin-right: 70px;
  text-align: right;
  svg {
    max-width: 20px;
    cursor: pointer;
    fill: #000;
  }
`

const VideoWithOverlay = ({ mediaUrl }) => {
  const [isOverlayVisible, setOverlayVisible] = useState(false)
  const videoRef = useRef(null)

  const toggleOverlay = () => {
    if (isOverlayVisible && videoRef.current) {
      videoRef.current.pause()
    }
    setOverlayVisible(!isOverlayVisible)
  }

  return (
    <QuestionVideoContainer>
      <QuestionVideContainerFilter onClick={toggleOverlay}>
        <VideoTriangleIcon />
      </QuestionVideContainerFilter>
      <QuestionVideoPoster src={`${mediaUrl}.jpg`} onClick={toggleOverlay} />
      <QuestionVideoOverlayContainer
        visible={isOverlayVisible}
        onClick={toggleOverlay}
      >
        <CloseIconContainer>
          <CloseIcon />
        </CloseIconContainer>
        <QuestionVideo
          ref={videoRef}
          controls
          playsInline
          poster={`${mediaUrl}.jpg`}
          onClick={(e) => e.stopPropagation()}
        >
          <source type="video/webm" src={`${mediaUrl}.webm`} />
          <source type="video/mp4" src={`${mediaUrl}.mp4`} />
        </QuestionVideo>
      </QuestionVideoOverlayContainer>
    </QuestionVideoContainer>
  )
}

VideoWithOverlay.propTypes = {
  mediaUrl: PropTypes.string,
}

VideoWithOverlay.defaultProps = {
  mediaUrl: {},
}

export default VideoWithOverlay
